import { useState, useEffect } from "react";
import NavBar from "../NavBar/NavBar";
import CreateEvaluation from "../CreateEvaluation/CreateEvaluation";
import "./style.css"
import EvaluationInstructions from "../EvaluationInstructions/EvaluationInstructions";
import EvaluationsList from "../EvaluationsList/EvaluationsList";

export default function Dashboard() {
  const [isSideNav, setIsSideNav] = useState(true);
  const [userId, setUserId] = useState(null); // State for the user ID
  const [instructionsOpen, setInstructionsOpen] = useState(false);


  return (
    <>
      <main className="web-view">
        <div className="dashboard">
          <div className="title-area">
            <h2 className="evaluation-dashboard-title">Evaluations</h2>
            <p>Here you can create, view, and learn more about the Athlete Experience Recognition Evaluation</p>
          </div>

          <div className="dashboard-section">
            <EvaluationInstructions/>
          </div>
          <div className="reflection-section">
            <CreateEvaluation />
          </div>
          <div className="date-section">
            <EvaluationsList/>
          </div>
        </div>
      </main>
    </>
  );
}
